import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAINTENANCE_NOTICE } from './maintenance-notice.constant';

@Component({
  selector: 'app-maintenance-notice',
  templateUrl: './maintenance-notice.component.html',
  styleUrls: ['./maintenance-notice.component.scss']
})
export class MaintenanceNoticeComponent {
  readonly notice = MAINTENANCE_NOTICE;

  constructor(public dialogRef: MatDialogRef<MaintenanceNoticeComponent>) { }

  close() {
    this.dialogRef.close();
  }
}
